<template>
    <div
        class="formFileArea"
        :class="{
            'is-filled': isFilled,
            'has-error': hasError,
            'has-success': hasSuccess,
        }"
    >
        <input
            ref="input"
            class="formFile"
            type="file"
            :id="`${name}InputField`"
            :name="name"
            :required="required"
            :accept="accept ? accept : false"
            @change="onFileChange"
        >

        <label
            class="formFileLabel"
            :for="`${name}InputField`"
        >
            <svg v-if="icon == 'media'" class="icon icon--media" width="53" height="52" fill="#5c2d91" stroke="#5c2d91" viewBox="0 0 53 52" aria-hidden="true">
                <path stroke-width="0" d="M6.84,46.54H46.92a1.13,1.13,0,0,0,.31-.06l.07,0,.07,0,.09-.08.14-.12.09-.14a.8.8,0,0,0,.08-.16.57.57,0,0,0,0-.18.45.45,0,0,0,0-.11V6.47a.92.92,0,0,0-.91-.92H6.84a.92.92,0,0,0-.91.92V45.63A.91.91,0,0,0,6.84,46.54ZM20.05,31l3.47,6-4.46,7.73h-7Zm13.2-7.27,12.09,21H21.17ZM7.75,7.38H46V42.23L34,21.49l0,0-.13-.14-.13-.12,0,0-.11,0-.18-.06h-.34a.85.85,0,0,0-.17.06l-.11,0,0,0-.14.12a1.49,1.49,0,0,0-.12.14l0,0-7.9,13.68-3.73-6.4s0,0,0,0a2.21,2.21,0,0,0-.25-.25s0,0,0,0a.3.3,0,0,0-.11,0,.64.64,0,0,0-.18-.06h-.34a.49.49,0,0,0-.17.06l-.12,0,0,0a2.21,2.21,0,0,0-.25.25l0,0-9.3,16H7.75Z"/>
                <rect x="2.24" y="1.48" width="49.07" height="49.07" rx="4" fill="none" stroke="#5c2d91" stroke-width="2" stroke-opacity=".5" />
                <path stroke-width="0" d="M16.86,19.21a2.73,2.73,0,1,0-2.73-2.73A2.74,2.74,0,0,0,16.86,19.21Zm0-3.64a.91.91,0,1,1-.91.91A.91.91,0,0,1,16.86,15.57Z"/>
                <path stroke-width="0" opacity=".5" d="M16.86,12.84a.91.91,0,0,0,.91-.91V11A.91.91,0,1,0,16,11v.91A.91.91,0,0,0,16.86,12.84Zm0,7.29A.91.91,0,0,0,16,21V22a.91.91,0,1,0,1.82,0V21A.9.9,0,0,0,16.86,20.13ZM13,13.91a.93.93,0,0,0,1.29,0,.92.92,0,0,0,0-1.29L13.64,12a.91.91,0,0,0-1.28,1.29Zm7.73,5.15a.91.91,0,1,0-1.29,1.29l.64.64a.91.91,0,1,0,1.29-1.29ZM11.4,17.39h.91a.91.91,0,0,0,0-1.82H11.4a.91.91,0,0,0,0,1.82Zm9.11-.91a.9.9,0,0,0,.91.91h.91a.91.91,0,0,0,0-1.82h-.91a.91.91,0,0,0-.91.91ZM13,19.06l-.65.64A.92.92,0,0,0,13,21.26a.89.89,0,0,0,.64-.27l.65-.64a.92.92,0,0,0,0-1.29A.91.91,0,0,0,13,19.06Zm7.08-4.89a1,1,0,0,0,.65-.26l.64-.65a.89.89,0,0,0,0-1.28.91.91,0,0,0-1.29,0l-.64.64a.91.91,0,0,0,0,1.29A.89.89,0,0,0,20.08,14.17Z"/>
            </svg>

            <svg v-if="icon == 'csv'" class="icon icon--csv" width="50" height="52" fill="#5c2d91" viewBox="0 0 19 20">
                <path d="M12.57,0h.11l.08,0h0a.27.27,0,0,1,.08.07h0l3.85,4.4a.35.35,0,0,1,.1.25v.05h0V7.17h.48a1.12,1.12,0,0,1,1.12,1.12h0v5.82a1.12,1.12,0,0,1-1.12,1.12h-.48v4A.78.78,0,0,1,16,20H3.1a.78.78,0,0,1-.78-.78h0v-4H1.84A1.12,1.12,0,0,1,.72,14.11h0V8.29A1.12,1.12,0,0,1,1.84,7.17h.48V.81A.78.78,0,0,1,3.1,0h9.47Zm3.19,15.18H3.3V19H15.76ZM5.41,8.86a2.19,2.19,0,0,0-2.24,2.3v.05A2.09,2.09,0,0,0,5.43,13.5a1.84,1.84,0,0,0,2-1.69h-1a1,1,0,0,1-1,.87c-.74,0-1.17-.54-1.17-1.48v0c0-.93.45-1.48,1.17-1.48a.86.86,0,0,1,.94.83h1A1.79,1.79,0,0,0,5.41,8.86Zm4.19,0c-1,0-1.64.57-1.64,1.34s.47,1.21,1.62,1.36c.66.11.85.23.85.59s-.29.6-.74.6c-.67,0-.84-.34-.88-.74h-1c.06.9.63,1.48,1.86,1.48a1.52,1.52,0,0,0,1.72-1.43c0-.94-.56-1.23-1.65-1.37-.69-.1-.84-.25-.84-.57s.23-.51.68-.51a.66.66,0,0,1,.75.59h.93C11.2,9.32,10.61,8.87,9.6,8.87Zm3.26.06H11.78l1.51,4.5h1.17L16,8.93H15l-1.07,3.46ZM12.37.78H3.3V7.14H15.76v-2h-3a.39.39,0,0,1-.39-.39h0Z"/>
            </svg>

            <span class="formFileLabel__text">{{ title }}</span>
            <small class="formFileLabel__size">{{ sizeLimit }}</small>
        </label>

        <div
            v-if="isFilled"
            class="formFileArea__actions"
        >
            <button
                class="uploadBtn"
                type="button"
                @click.stop.prevent="$refs.input.click()"
            >
                <span class="visually-hidden">Upload</span>
                <svg class="icon icon--upload" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M12.47,4.25,8.53.3A.75.75,0,0,0,7.47.3l-3.94,4a.74.74,0,1,0,1.05,1L7.26,2.62v7.94a.74.74,0,0,0,1.48,0V2.62L11.42,5.3a.74.74,0,1,0,1.05-1Z"/>
                    <path d="M15.17,14.43H.83a.75.75,0,0,0-.75.74.76.76,0,0,0,.75.75H15.17a.76.76,0,0,0,.75-.75A.75.75,0,0,0,15.17,14.43Z"/>
                </svg>
            </button>

            <button
                class="deleteBtn"
                type="button"
                @click.stop.prevent="clearFile"
            >
                <span class="visually-hidden">Delete</span>
                <svg class="icon icon--trash" width="13" height="15" fill="#5c2d91" viewBox="0 0 12.86 14.64">
                    <path d="M.89,4.29l.76,9.17,0,.13a1.3,1.3,0,0,0,1.26,1.05h7.13a1.29,1.29,0,0,0,1.15-1.17L12,4.29Zm3.82,8.25a.43.43,0,0,1-.85,0L3.43,5.6V5.52a.43.43,0,0,1,.4-.37.42.42,0,0,1,.46.4l.43,6.91Zm2.15,0v.08a.42.42,0,0,1-.42.35A.43.43,0,0,1,6,12.49v-7a.43.43,0,0,1,.85.07Zm2.14,0v.07a.43.43,0,0,1-.84-.13l.43-6.91V5.47A.42.42,0,0,1,9,5.15a.41.41,0,0,1,.4.45Z"/>
                    <path d="M12,1.72H9.43V1.15A1.3,1.3,0,0,0,8.15,0H4.59A1.28,1.28,0,0,0,3.43,1.29v.43H.75A.86.86,0,0,0,0,2.57a.85.85,0,0,0,.86.86H12.11a.85.85,0,0,0-.1-1.7Zm-3.43,0H4.29V1.21A.44.44,0,0,1,4.72.86H8.15a.43.43,0,0,1,.43.43Z"/>
                </svg>
            </button>
        </div>
    </div>
</template>



<script>
import { formatBytes } from '../../utils/utils'




/* FILE INPUT
---------------------------------------------------------------------------------------------------- */

export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'FileInput',


    components: {
        //
    },


    props: {
        required: { type: Boolean, default: false },
        name: { type: String, required: true },
        instructions: { type: String, required: true },
        maxSizePrefix: { type: String, required: true },
        maxSize: { type: Number, required: true },
        currentFileName: { type: String },
        accept: { type: String, default: '' },
        icon: { type: String, default: 'media' },
    },


    data() {
        return {
            visibleName: this.$props.currentFileName,
            currentSize: null,
        }
    },




    /* Life cycle
    --------------------------------------------------------- */

    created() {
        //
    },


    mounted() {
        //
    },




    /* Data handling
    --------------------------------------------------------- */

    watch: {
        //
    },


    computed: {
        title() {
            return this.$data.visibleName || this.$props.instructions
        },


        sizeLimit() {
            return `${this.$props.maxSizePrefix} ${formatBytes(this.$props.maxSize)}`
        },


        isFilled() {
            return Boolean(this.$data.visibleName)
        },


        hasError() {
            return this.$data.currentSize > this.$props.maxSize
        },


        hasSuccess() {
            return Boolean(this.$data.visibleName && !this.hasError)
        },
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {

        /* Handlers
        --------------------------------------------------------- */

        onFileChange() {
            const { input } = this.$refs
            const { files } = input

            this.$data.visibleName = (files.length) ? files[0].name : null
            this.$data.currentSize = (files.length) ? files[0].size : null
        },




        /* Actions
        --------------------------------------------------------- */

        clearFile() {
            this.$refs.input.value = null
            this.onFileChange()
        },

    },

}
</script>
